module.exports = __webpack_public_path__ + "img/passenger.10155cd4.svg";